import React from 'react'
import { css } from '@mxenabled/cssinjs'

import { ChevronLeft, ChevronRight } from '@mxenabled/mx-icons'

import Button from '@mui/material/Button'

import { H2 } from '@mxenabled/mxui'

import { DATE_FORMATS_INTL, formatDate } from '../../../core/constants'

import type { CalendarCopy } from './Calendar'

interface HeaderProps {
  copy: CalendarCopy
  date: Date
  onNextClick: () => void
  onPreviousClick: () => void
}

const Header: React.FC<HeaderProps> = ({ copy, date, onNextClick, onPreviousClick }) => {
  const styles = getStyles()

  return (
    <div className={`mx-cmn-calendar-header ${styles}`}>
      <H2 className="mx-cmn-calendar-header-title" variant="h3">
        {formatDate(date, DATE_FORMATS_INTL.MONTH_YEAR)}
      </H2>
      <div className="mx-cmn-calendar-header-button-container">
        <Button aria-label={copy.prevAria} onClick={onPreviousClick}>
          <ChevronLeft size={24} />
        </Button>
        <Button aria-label={copy.nextAria} onClick={onNextClick}>
          <ChevronRight size={24} />
        </Button>
      </div>
    </div>
  )
}

const getStyles = () =>
  css({
    alignItems: 'center',
    display: 'flex',
    marginBottom: 16,
    marginRight: -16,
    paddingLeft: 8,
    '& .mx-cmn-calendar-header-title': {
      flexGrow: 1,
    },
    '& .mx-cmn-calendar-header-button-container': {
      display: 'flex',
      gap: 4,
    },
  })

export default Header
